import localScaleManager from "../../../../helpers/LocalScaleManager";
import { Parser } from "../../../../helpers/parser";
import Button from "../../../modals/objects/button";

export default class FastBetButton extends Button {
  constructor(scene, index, text, parent, table) {
    super(scene, "fast-btn", true, table);
    this.scene = scene;
    this.parent = parent;
    this.index = index;
    this.table = table;
    this.textBtn = text.padStart(8 - text.length, "0");
    this.text = this.scene.add.bitmapText(
      0,
      0,
      "HelveticaNeueTeal",
      Parser.convertToXLetters(this.textBtn, 8)
    );
    this.table.poolArray.push(this.text);

    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);
    this.on("pointerup", this.onFastBetClick); //D
  }
  onFastBetClick() {
    this.disableInteractive();
    this.onClick(() => {
      let raiseValue = 0;
      switch (this.textBtn) {
        case "Max": {
          raiseValue = this.parent.maxRaise;
          break;
        }
        case "2/3Pot": {
          raiseValue = Math.trunc(
            (this.parent.pot * 2) / 3 + this.parent.playerBet
          );
          break;
        }
        case "1/2Pot": {
          raiseValue = Math.trunc(this.parent.pot / 2 + this.parent.playerBet);
          break;
        }
        case "Min": {
          raiseValue = this.parent.minRaise;
          break;
        }
        case "Pot": {
          raiseValue = this.parent.pot + this.parent.playerBet;
          break;
        }
        case "3/4Pot": {
          raiseValue = Math.trunc(
            (this.parent.pot * 3) / 4 + this.parent.playerBet
          );
          break;
        }
        case "2X": {
          raiseValue = Math.trunc(this.parent.maxBet * 2);
          break;
        }
        case "3X": {
          raiseValue = Math.trunc(this.parent.maxBet * 3);
          break;
        }
        case "Disabled": {
          this.disableInteractive();
          break;
        }
      }
      this.parent.menuInput.setValue(raiseValue);
      this.parent.menuWheel.fillByAmount(raiseValue);
      this.enableInteractive();
    });
  }
  updateTxt(text) {
    this.textBtn = text;
    this.text.setText(Parser.convertToXLetters(this.textBtn, 8));
    this.enableInteractive();
  }
  /**
   *
   * @param width -> available width
   * @param btnSize -> btn size
   * @param initX -> table x
   * @param initY -> raise menu y
   */
  positionControls(width, btnSize, initX, initY) {
    localScaleManager.scaleSprite(this, width / 3.3, width / 3.3, 0, 1, true);
    const distanceBetweenButtons = this.displayWidth / 18;

    // this.setPosition( initX + width / 20, initY +  firstButtonY + this.index * (this.displayHeight + distanceBetweenButtons));
    this.setPosition(
      initX +
        (this.index + 1) * distanceBetweenButtons +
        (this.index * 2 + 1) * (this.displayWidth / 2),
      initY
    );

    localScaleManager.scaleBitMapText(
      this.text,
      this.displayWidth / 1.5,
      this.displayHeight,
      Math.min(this.text.width, this.text.height) * 0.2,
      1,
      false
    );
    this.text.setPosition(
      this.x - this.text.width / 2,
      this.y - this.text.height / 2
    );
  }
  reposition(width, btnSize, initX, initY) {
    const distanceBetweenButtons = this.displayWidth / 18;
    this.setPosition(
      initX +
        (this.index + 1) * distanceBetweenButtons +
        (this.index * 2 + 1) * (this.displayWidth / 2),
      initY
    );
    this.text.setPosition(
      this.x - this.text.width / 2,
      this.y - this.text.height / 2
    );
  }
  remove() {
    this.destroy();
    this.text.destroy();
  }
}
